'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPage = fetchPage;
exports.isPageLoaded = isPageLoaded;

var _Api = require('shared/redux/utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPath = function getPath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return pathname.split('/').filter(function (el) {
    return el;
  }).join('/');
};

function fetchPage(path) {
  return {
    type: _types.FETCH_PAGE,
    meta: { path: getPath(path) },
    promise: _Api2.default.fetch(path)
  };
}

function isPageLoaded(state, page) {
  return !!state.pages[getPath(page)];
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/actions.js
// module id = 1102
// module chunks = 0